import React, { Fragment, useEffect, useRef, useState } from "react";
import BaseButton from "../../components/base-button/base-button";
import useModal from "../../hooks/use-modal";

/**
 * Components
 */

const ModalQuestionComment = (props) => {
  const { question, comment, onSave } = props.modalProps;
  const { closeModal } = useModal();
  const inputRef = useRef();

  return (
    <Fragment>
      <h3>Additional Comments</h3>
      <p style={{ color: "#0E1B5B" }}>
        {question.order}. {question.question}
      </p>
      <textarea
        style={{
          width: "100%",
          border: "1px solid #C3CAD9",
          borderRadius: "10px",
          padding: "10px",
          marginTop: "10px",
        }}
        ref={inputRef}
        defaultValue={comment}
        maxLength={500}
      />
      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <BaseButton
          onClick={() => onSave(question.id, inputRef.current.value)}
          type="button"
          className="btn--primary"
          style={{
            width: "100%",
            marginBottom: "10px",
            marginTop: "10px",
          }}
        >
          Save
        </BaseButton>
        <BaseButton
          onClick={closeModal}
          type="button"
          className="btn--alt"
          style={{
            width: "100%",
          }}
        >
          Cancel
        </BaseButton>
      </div>
    </Fragment>
  );
};

export default ModalQuestionComment;
